var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "is-form",
      attrs: { visible: _vm.visible },
      on: {
        closeModal: function ($event) {
          _vm.visible = false
        },
      },
    },
    [
      _c("template", { slot: "header" }, [
        _vm._v("Herkunft und Tags bearbeiten"),
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticStyle: { "min-height": "100px" },
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _vm.isLoading ? _c("loading") : _vm._e(),
          _vm._v(" "),
          _c("table", [
            _c("tr", [
              _c("th", [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Herkunft der Anfrage"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("multiselect", {
                    staticClass: "is-shorter",
                    attrs: {
                      options: _vm.options.requestSourceList || [],
                      label: "value",
                      "track-by": "key",
                      placeholder: "Herkunft der Anfrage",
                      "allow-empty": false,
                    },
                    model: {
                      value: _vm.formRequestSource,
                      callback: function ($$v) {
                        _vm.formRequestSource = $$v
                      },
                      expression: "formRequestSource",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("th", [
                _c("label", { staticClass: "label" }, [_vm._v("Tags")]),
              ]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c(
                    "multiselect",
                    {
                      attrs: {
                        options: _vm.options.orderTags
                          ? _vm.options.orderTags
                          : [],
                        taggable: true,
                        multiple: "",
                      },
                      on: { tag: _vm.addTag },
                      model: {
                        value: _vm.traitTags,
                        callback: function ($$v) {
                          _vm.traitTags = $$v
                        },
                        expression: "traitTags",
                      },
                    },
                    [_c("span", { attrs: { slot: "caret" }, slot: "caret" })]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.isGrantedAdmin && _vm.useTagsForCommission
              ? _c(
                  "tr",
                  {
                    class: {
                      "is-proposed":
                        _vm.proposedFields.includes("commissionSource"),
                    },
                  },
                  [
                    _c("th", [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Provisionsquelle"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", { staticClass: "level" }, [
                        _c(
                          "div",
                          {
                            staticClass: "level-left",
                            staticStyle: { flex: "1" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "level-item",
                                staticStyle: { flex: "1" },
                              },
                              [
                                _c("multiselect", {
                                  staticClass: "is-shorter",
                                  attrs: {
                                    options: _vm.commissionSourceOptions,
                                    label: "value",
                                    "track-by": "key",
                                    placeholder: "Provisionsquelle",
                                  },
                                  model: {
                                    value: _vm.formCommissionSource,
                                    callback: function ($$v) {
                                      _vm.formCommissionSource = $$v
                                    },
                                    expression: "formCommissionSource",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.proposedFields.includes("commissionSource")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "level-item",
                                    staticStyle: { flex: "none" },
                                  },
                                  [
                                    _c(
                                      "popover",
                                      { attrs: { trigger: "hover" } },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons is-small has-text-link",
                                          },
                                          [_vm._v("info")]
                                        ),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _vm._v(
                                            "Vorschlag basierend auf dem Tag – derzeit kein Wert gespeichert"
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isGrantedAdmin && _vm.useTagsForCommission
              ? _c(
                  "tr",
                  {
                    class: {
                      "is-proposed": _vm.proposedFields.includes("commission"),
                    },
                  },
                  [
                    _c("th", [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Provision (in %)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", { staticClass: "level" }, [
                        _c(
                          "div",
                          {
                            staticClass: "level-left",
                            staticStyle: { flex: "1" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "level-item",
                                staticStyle: { flex: "1" },
                              },
                              [
                                _c("input-price", {
                                  attrs: {
                                    digits: 1,
                                    nullable: true,
                                    prefix: "",
                                  },
                                  model: {
                                    value: _vm.commission,
                                    callback: function ($$v) {
                                      _vm.commission = $$v
                                    },
                                    expression: "commission",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.proposedFields.includes("commission")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "level-item",
                                    staticStyle: { flex: "none" },
                                  },
                                  [
                                    _c(
                                      "popover",
                                      { attrs: { trigger: "hover" } },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons is-small has-text-link",
                                          },
                                          [_vm._v("info")]
                                        ),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _vm._v(
                                            "Vorschlag basierend auf dem Tag – derzeit kein Wert gespeichert"
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isGrantedAdmin && _vm.useTagsForCommission
              ? _c(
                  "tr",
                  {
                    class: {
                      "is-proposed": _vm.proposedFields.includes(
                        "commissionCostDeduction"
                      ),
                    },
                  },
                  [
                    _c("th", [
                      _c("label", { staticClass: "label" }, [
                        _vm._v("Provisionsabzug (in %)"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", { staticClass: "level" }, [
                        _c(
                          "div",
                          {
                            staticClass: "level-left",
                            staticStyle: { flex: "1" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "level-item",
                                staticStyle: { flex: "1" },
                              },
                              [
                                _c("input-price", {
                                  attrs: {
                                    digits: 1,
                                    nullable: true,
                                    prefix: "",
                                  },
                                  model: {
                                    value: _vm.commissionCostDeduction,
                                    callback: function ($$v) {
                                      _vm.commissionCostDeduction = $$v
                                    },
                                    expression: "commissionCostDeduction",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.proposedFields.includes(
                              "commissionCostDeduction"
                            )
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "level-item",
                                    staticStyle: { flex: "none" },
                                  },
                                  [
                                    _c(
                                      "popover",
                                      { attrs: { trigger: "hover" } },
                                      [
                                        _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons is-small has-text-link",
                                          },
                                          [_vm._v("info")]
                                        ),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _vm._v(
                                            "Vorschlag basierend auf dem Tag – derzeit kein Wert gespeichert"
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          { staticClass: "button is-large", on: { click: _vm.close } },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("close")]),
            _vm._v(" Verwerfen"),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-primary is-large",
            class: { "is-loading": _vm.isLoading },
            on: { click: _vm.saveForm },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("check")]),
            _vm._v(" Speichern"),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }